import React from 'react';
import PropTypes from 'prop-types';
import {
  Table,
  TableBody,
  TableHeader,
  TableRow,
  TableHeaderColumn,
  TableSortableHeaderColumn,
} from '@unite-us/app-components';
import ReferralTableRow from './ReferralTableRow';
import { PROGRAM_COLUMN_WIDTH } from '../utils/tableLayout';
import '../stylesheets/facesheetTable.scss';

const ReferralTableView = (props) => {
  const {
    referrals,
    styles,
    groupId,
    isCC,
    sortBy,
    sortDirection,
    fetchReferrals,
    onSortChange,
    showProgramName,
    standardizedTable,
  } = props;

  const setSort = ({ sortBy: sortid, sortDirection: sortD }) => {
    if (onSortChange) {
      onSortChange(sortid, sortD);
      return;
    }

    fetchReferrals(1, sortid, sortD);
  };

  return (
    <div className="referral-table-view">
      <Table
        id="referral-table-view"
        noBorder
        className={standardizedTable ? 'facesheet-table' : ''}
      >
        <TableHeader
          adjustForCheckbox={false}
          displaySelectAll={false}
        >
          <TableRow>
            <>
              <TableHeaderColumn />
              <TableHeaderColumn>
                Service Type
              </TableHeaderColumn>

              {showProgramName && (
                <TableSortableHeaderColumn
                  style={standardizedTable ? { width: PROGRAM_COLUMN_WIDTH } : {}}
                  colName={'referred_to_program.name'}
                  sortBy={sortBy}
                  sortDirection={sortDirection}
                  setSort={setSort}
                >
                  Program
                </TableSortableHeaderColumn>
              )}

              <TableSortableHeaderColumn
                colName={'created_at'}
                sortBy={sortBy}
                sortDirection={sortDirection}
                setSort={setSort}
              >
                Date Sent
              </TableSortableHeaderColumn>

              <TableHeaderColumn style={{ minWidth: '65px' }}>
                Status
              </TableHeaderColumn>

              <TableHeaderColumn>
                Sending Organization
              </TableHeaderColumn>

              <TableHeaderColumn>
                Receiving Organization
              </TableHeaderColumn>

              <TableSortableHeaderColumn
                colName={'updated_at'}
                sortBy={sortBy}
                sortDirection={sortDirection}
                setSort={setSort}
              >
                Last Updated
              </TableSortableHeaderColumn>
            </>
          </TableRow>
        </TableHeader>
        <TableBody
          displayRowCheckbox={false}
          showRowHover
        >
          {
            referrals.map((referral, index) => (
              <ReferralTableRow
                key={referral.id}
                isCC={isCC}
                referral={referral}
                index={index}
                styles={styles}
                groupId={groupId}
                showProgramName={showProgramName}
                standardizedTable={standardizedTable}
              />
            ))
          }
        </TableBody>
      </Table>
    </div>
  );
};

ReferralTableView.propTypes = {
  referrals: PropTypes.array.isRequired,
  groupId: PropTypes.string.isRequired,
  isCC: PropTypes.bool.isRequired,
  styles: PropTypes.shape({
    status: PropTypes.object.isRequired,
  }).isRequired,
  sortBy: PropTypes.string.isRequired,
  sortDirection: PropTypes.string.isRequired,
  fetchReferrals: PropTypes.func.isRequired,
  onSortChange: PropTypes.func,
  showProgramName: PropTypes.bool,
  standardizedTable: PropTypes.bool,
};

ReferralTableView.defaultProps = {
  styles: {
    status: { textTransform: 'capitalize', minWidth: '65px' },
  },
  showProgramName: false,
  standardizedTable: false,
};

export default ReferralTableView;
